export default __webpack_public_path__ + "static/media/plus.48ab758a.svg";